// Hosts where the service worker script is served directly from the page origin.
// Anywhere else (the apex domain, Vercel preview URLs) /sw.js sits behind a
// redirect or an auth wall, and registration is guaranteed to fail.
const SERVICE_WORKER_HOSTS = ['www.simplestickers.app', 'localhost', '127.0.0.1'];

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;
  if (!SERVICE_WORKER_HOSTS.includes(window.location.hostname)) return;

  window.addEventListener('load', () => {
    // Registration can still fail for reasons outside our control (corporate
    // proxies returning 407, offline clients). Swallow it: the app works fine
    // without the service worker, it just loses offline caching.
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
      console.warn('Service worker registration failed:', error);
    });
  });
}
